export default "__VITE_ASSET__DAJq3O7t__"